module.exports = authenticationPlugin;
var _require = require("deprecation"),
  Deprecation = _require.Deprecation;
var once = require("once");
var deprecateAuthenticate = once(function (log, deprecation) {
  return log.warn(deprecation);
});
var authenticate = require("./authenticate");
var beforeRequest = require("./before-request");
var requestError = require("./request-error");
function authenticationPlugin(octokit, options) {
  if (options.auth) {
    octokit.authenticate = function () {
      deprecateAuthenticate(octokit.log, new Deprecation('[@octokit/rest] octokit.authenticate() is deprecated and has no effect when "auth" option is set on Octokit constructor'));
    };
    return;
  }
  var state = {
    octokit: octokit,
    auth: false
  };
  octokit.authenticate = authenticate.bind(null, state);
  octokit.hook.before("request", beforeRequest.bind(null, state));
  octokit.hook.error("request", requestError.bind(null, state));
}